import { render, staticRenderFns } from "./KpiZuhe.vue?vue&type=template&id=7037247d&scoped=true&"
import script from "./KpiZuhe.vue?vue&type=script&lang=js&"
export * from "./KpiZuhe.vue?vue&type=script&lang=js&"
import style0 from "./KpiZuhe.vue?vue&type=style&index=0&id=7037247d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037247d",
  null
  
)

export default component.exports